<script>
import * as types from '@/vuex/mutation-types'
export default {
  computed: {
    isSidebarActive: function () {
      return this.$store.state.globalStore.isSidebarActive
    },
    isTopNavbarActive: function () {
      return this.$store.state.globalStore.isTopNavbarActive
    }
  },
  methods: {
    toggleSidebarNav: function () {
      this.$store.dispatch(types.TOGGLE_SIDEBAR_NAV)
    },
    toggleTopNavBar: function () {
      this.$store.dispatch(types.TOGGLE_TOP_NAVBAR)
    }
  }
}
</script>
